import Table from "rc-table";
import { format } from "date-fns";

export const ProductTable = ({ data }) => {
  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: 40,
    },
    {
      title: "TITLE",
      dataIndex: "title",
      key: "title",
      width: 40,
    },
    {
      title: "PRODUCT TYPE",
      render: ({ product_type: { name } }) => name,
      key: "product_type",
      width: 150,
    },
    {
      title: "USER",
      render: ({
        member: {
          user: { first_name, last_name },
        },
      }) => `${first_name} ${last_name}`,
      key: "user",
      width: 160,
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
      width: 50,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      width: 350,
    },
    {
      title: "Date Added",
      render: ({ created_at }) => format(new Date(created_at), "yyyy-MM-dd"),
      key: "created_at",
      width: 150,
    },
    {
      title: "Zip Code",
      dataIndex: "zipcode",
      key: "zipcode",
      width: 70,
    },
    {
      title: "Avg Rating",
      dataIndex: "avg_rating",
      key: "avg_rating",
      width: 80,
    },
    {
      title: "# Ratings",
      dataIndex: "count_ratings",
      key: "count_ratings",
      width: 100,
    },
  ];
  if (!data) {
    return <div />;
  }

  return (
    <Table
      columns={columns}
      data={data}
      tableLayout="auto"
      rowKey={Math.random()}
    />
  );
};
